/* MagFit v7: zaakceptowany cennik. Publikacja wymaga testu zgodności wariantów Shopify. */
(function () {
  'use strict';
  const config = {
    demoMode: false,
    minimumDays: 5,
    cutoffHour: 23,
    cutoffMinute: 59,
    leadCalendarDays: 2,
    timeZone: 'Europe/Warsaw',
    products: [
      { id: 'balance', name: 'Balance', emoji: '', description: 'Zbilansowana propozycja na co dzień.', priceFrom: 56.25, variantId: null },
      { id: 'redukcja', available: false, name: 'Redukcja', emoji: '', description: 'Propozycja dla osób kontrolujących kaloryczność posiłków.', priceFrom: 56.25, variantId: null },
      { id: 'sport', name: 'Sport', emoji: '', description: 'Propozycja dla osób aktywnych fizycznie.', priceFrom: 56.25, variantId: null },
      { id: 'lowcarb', name: 'Low Carb', emoji: '', description: 'Model jedzenia z ograniczonym udziałem węglowodanów.', priceFrom: 56.25, variantId: null },
      { id: 'vege', available: false, name: 'Vege', emoji: '', description: 'Dieta bez mięsa i ryb; może zawierać jaja i nabiał. Nie oznacza diety wegańskiej.', priceFrom: 56.25, variantId: null },
      { id: 'sibo', name: 'SIBO / Low FODMAP', emoji: '', description: 'Wariant do omówienia ze specjalistą. Dopasowanie do Low FODMAP i indywidualnych zaleceń wymaga potwierdzenia.', priceFrom: 56.25, variantId: null }
    ],
    images: {
      balance: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_19.png',
      redukcja: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_32.png',
      sport: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_17.png',
      lowcarb: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_13.png',
      vege: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_23.png',
      sibo: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_29.png'
    },
    // Liczba posiłków nie zmienia ceny; cena zależy od diety i kaloryczności.
    kcalOptions: [1300,1500,1800,2000,2500,3000,3500].map(kcal => ({kcal})),
    prices: {
      balance: [75,85,90,95,110,125,135],
      redukcja: [80,90,95,100,115,130,145],
      sport: [80,90,95,100,115,130,145],
      lowcarb: [80,90,95,100,115,130,145],
      vege: [85,99,105,110,120,140,150],
      sibo: [85,99,105,110,120,140,150]
    },
    mealOptions: [{count:3,factor:1},{count:4,factor:1},{count:5,factor:1}],
    discountCodes: {},
    delivery: {
      provisional: true,
      cost: 0,
      window: 'wieczorem poprzedzającym dzień diety',
      postcodeVerification: 'FORMAT_ONLY',
      // Puste postcodes NIE oznacza potwierdzenia każdego kodu. Weryfikujemy tylko format.
      // Punkty miejscowości wg GUGiK; lista i pełne adresy wymagają akceptacji przed startem.
      locations: [
        { name: 'Stargard', simc: '0979596', postcodes: [] },
        { name: 'Grabowo', simc: '0783338', postcodes: [] },
        { name: 'Grzędzice', simc: '0783373', postcodes: [] },
        { name: 'Klępino', simc: '0783410', postcodes: [] },
        { name: 'Kunowo', simc: '0777591', postcodes: [] },
        { name: 'Lipnik', simc: '0783462', postcodes: [] },
        { name: 'Lubowo', simc: '0783479', postcodes: [] },
        { name: 'Skalin', simc: '0783545', postcodes: [] },
        { name: 'Strachocin', simc: '0783597', postcodes: [] },
        { name: 'Święte', simc: '0783640', postcodes: [] },
        { name: 'Tychowo', simc: '0783663', postcodes: [] },
        { name: 'Ulikowo', simc: '0783670', postcodes: [] },
        { name: 'Witkowo Drugie', simc: '0783723', postcodes: [] },
        { name: 'Witkowo Pierwsze', simc: '0783746', postcodes: [] },
        { name: 'Zieleniewo', simc: '0777705', postcodes: [] },
        { name: 'Żarowo', simc: '0783752', postcodes: [] }
      ]
    }
  };
  config.products.forEach(p => { p.priceFrom = Math.min(...config.prices[p.id]); });
  window.MAGFIT_CONFIG = config;
  const money = value => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(value);

  function enhance(root) {
    root.querySelectorAll('[data-magfit-kcal-range]').forEach(el => {
      el.textContent = Math.min(...config.kcalOptions.map(o => o.kcal)) + '–' + Math.max(...config.kcalOptions.map(o => o.kcal));
    });
    root.querySelectorAll('[data-magfit-meal-range]').forEach(el => {
      el.textContent = Math.min(...config.mealOptions.map(o => o.count)) + '–' + Math.max(...config.mealOptions.map(o => o.count));
    });
    root.querySelectorAll('[data-magfit-price]').forEach(el => {
      if (!config.products.some(p => p.id === el.dataset.magfitPrice)) return;
      el.textContent = 'od ' + money(config.products.find(p => p.id === el.dataset.magfitPrice).priceFrom) + ' / dzień';
    });
    root.querySelectorAll('[data-magfit-price-note]').forEach(el => {
      el.textContent = window.location.pathname === '/' ? 'Liczba posiłków nie zmienia ceny.' : '1300 kcal · min. 5 dni pon.–pt. · liczba posiłków nie zmienia ceny.';
    });
    root.querySelectorAll('[data-magfit-delivery]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const city = box.querySelector('[data-delivery-city]');
      const postcode = box.querySelector('[data-delivery-postcode]');
      const result = box.querySelector('[data-delivery-result]');
      const submit = box.querySelector('[data-delivery-submit]');
      const order = box.querySelector('[data-delivery-order]');
      const list = box.querySelector('[data-delivery-list]');
      config.delivery.locations.forEach(location => {
        const option = document.createElement('option');
        option.value = location.name;
        option.textContent = location.name;
        city.append(option);
        const item = document.createElement('li');
        item.textContent = location.name;
        list.append(item);
      });
      const other = document.createElement('option');
      other.value = '__outside';
      other.textContent = 'Mojej miejscowości nie ma na liście';
      city.append(other);
      function reset() { result.textContent = ''; order.hidden = true; }
      city.addEventListener('change', reset);
      postcode.setAttribute('inputmode','numeric');
      postcode.addEventListener('input', function(){
        const digits=postcode.value.replace(/\D/g,'').slice(0,5);
        postcode.value=digits.length>2?digits.slice(0,2)+'-'+digits.slice(2):digits;
        reset();
      });
      submit.addEventListener('click', function () {
        order.hidden = true;
        const location = config.delivery.locations.find(item => item.name === city.value);
        if (!location) {
          result.textContent = city.value === '__outside' ? 'Ta miejscowość nie jest na liście. Nie możesz wybrać tego adresu w konfiguratorze. Skontaktuj się z nami w sprawie rozszerzenia strefy.' : 'Wybierz miejscowość z listy.';
          city.focus();
          return;
        }
        if (!/^\d{2}-\d{3}$/.test(postcode.value.trim())) {
          result.textContent = 'Podaj kod pocztowy w formacie 99-999.';
          postcode.focus();
          return;
        }
        result.textContent = '✓ Dostarczamy do miejscowości ' + location.name + '. Twoją dietę przywieziemy wieczorem na kolejny dzień. Kod ma poprawny format; dostępność konkretnego adresu potwierdzamy przy zamówieniu.';
        order.hidden = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document));
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
